// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  madeByGdmAPIV1: {
    url: 'http://localhost:4200/assets/data/api/v1',
    endPoints: {
      articles: '/articles.json',
      posts: '/posts.json',
      international: '/international.json',
      internships: '/internships.json',
      testimonies: '/testimonies.json'
    }
  },
  trotsAPI: {
    url: 'http://www.gdm.gent/trots/api',
    endPoints: {
      projects: '/projects.json',
    }
  }
};



// WEBPACK FOOTER //
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/environments/environment.ts